import { useEffect } from 'react';

/**
 * Hook to set a CSS custom property --vh based on actual viewport height
 * This is a fallback for older iOS versions that don't support dvh units
 * Addresses the iOS Safari bottom toolbar issue
 */
export function useViewportHeightVar() {
  useEffect(() => {
    const setVh = () => {
      // Get actual viewport height and calculate 1vh value
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    
    // Set initially
    setVh();
    
    // Update on resize and orientation change
    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', setVh);
    
    // Also listen for visualViewport resize if available (iOS 13+)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', setVh);
    }
    
    return () => {
      window.removeEventListener('resize', setVh);
      window.removeEventListener('orientationchange', setVh);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', setVh);
      }
    };
  }, []);
}